import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { clearEntities } from '../../../actions/entities';
import { error } from '../../../actions/general';
import {
  clearPublicKey,
  createSession,
  getRoute,
  loading,
} from '../../../actions/sessions';
import { subDomains } from '../../../lib/constants/SiteVariables';
import Loading from '../../shared/Loading';

export default function ApplyNow({ match }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  useEffect(() => {
    dispatch(loading(true));
    dispatch(clearPublicKey());
    dispatch(
      createSession(
        match.params.merchant_public_key,
        match.params.prequalification_id,
        query.get('invite_slug'),
        subDomains.authorized() ? [subDomains.subDomain()] : []
      )
    )
      .then((res) => {
        dispatch(clearEntities('application'));
        dispatch(clearEntities('company'));
        dispatch(clearEntities('user'));
      })
      .then((res) => dispatch(getRoute()))
      .catch((err) => {
        dispatch(error(err));
        history.push('/error');
      });
  }, []);

  return (
    <div data-testid="applynow" className="mx-3 sm:mx-auto">
      <Loading
        className="w-14 h-14"
        containerClass="my-24 sm:my-0 min-h-[30vh]"
      />
    </div>
  );
}
